import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  stickyHeader: css`
    display: flex;
    position: sticky;
    top: 0;
    width: 100%;
    flex-direction: column;
    z-index: 1199;
  `,
  title: css`
    text-transform: capitalize;
  `,
  container: css`
    .MuiPaper-root {
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.25);
    }
    &.MuiModal-root {
      z-index: 99999;
    }
  `,
  full: css`
    .MuiPaper-root {
      height: 100%;
    }
  `,
  drawerIcon: css`
    .MuiSvgIcon-root {
      color: ${colors.prussianMid};
    }
  `,
  closeOptionsIcon: css`
    position: absolute;
    left: 10px;
  `,
  list: css`
    &.MuiList-root {
      padding-bottom: 0px;
    }
  `,
};

export default styles;
